import { Fancybox } from '@fancyapps/ui';

(function () {
  'use strict';

  const selectors = {
    galleryContentContainer: '.js-gallery'
  };

  const init = () => {
    const galleryContentContainers = document.querySelectorAll(selectors.galleryContentContainer);

    galleryContentContainers.forEach((gallery) => {
      if (gallery instanceof HTMLElement) {
        Fancybox.bind('[data-fancybox]', {
          Toolbar: {
            display: {
              left: ['infobar'],
              middle: ['rotateCW'],
              right: [
                'iterateZoom',
                'slideshow',
                'thumbs',
                'close'
              ]
            }
          },
          Images: {
            initialSize: 'fit'
          }
        });
      }
    });
  };

  window.addEventListener('load', init);
})();
